export default __webpack_public_path__ + "static/media/1891.66513c3d.png";